export function SAVE_FILTERS(state, [favorite, progress, search, selected_areas, subscription_type, selected_groups, selected_tags]){
    state.favorite = favorite
    state.progress = progress
    state.search = search
    state.selected_areas = selected_areas
    state.subscription_type = subscription_type
    state.selected_groups = selected_groups
    state.selected_tags = selected_tags
}

export function SAVE_PROGRESS(state, progress){
    state.progress = progress
}

export function SAVE_FILTER_AREA(state, selected_areas){
    state.selected_areas = selected_areas
}

export function SAVE_LOADING(state, loading){
    state.loading = loading
}